import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, TextField, CircularProgress, Stack, useTheme } from "@mui/material";
import { fetchCaptcha } from "../../redux/state/captchaReduser/captchaFetch";
import {
  selectCaptchaImage,
  selectCaptchaText,
  selectCaptchaStatus,
} from "../../redux/state/captchaReduser/captchaSelectors";

function Captcha({ onSuccess }) {
  const dispatch = useDispatch();
  const theme = useTheme(); // Используем тему
  const isDarkMode = theme.palette.mode === "dark"; // Проверяем текущий режим

  const image = useSelector(selectCaptchaImage);
  const text = useSelector(selectCaptchaText);
  const status = useSelector(selectCaptchaStatus);

  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    dispatch(fetchCaptcha());
  }, [dispatch]);

  const handleSubmit = () => {
    if (inputValue.trim().toLowerCase() === text.toLowerCase()) {
      setError("");
      onSuccess();
    } else {
      setError("Неверная капча!");
      dispatch(fetchCaptcha());
      setInputValue("");
    }
  };

  const handleRefresh = () => {
    dispatch(fetchCaptcha());
    setError("");
    setInputValue("");
  };

  return (
    <Box sx={{ textAlign: "center", mt: 2, mb:5 }}>
      {status === "loading" ? (
        <CircularProgress />
      ) : (
        <Box
          sx={{
            backgroundColor: isDarkMode ? "#333" : "#f0f0f0",
            padding: 1,
            display: "inline-block",
            borderRadius: 1,
          }}
          dangerouslySetInnerHTML={{ __html: image }}
        />
      )}

      <TextField
        label="Введите код"
        variant="outlined"
        fullWidth
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        error={!!error}
        helperText={error}
        sx={{ mt: 2 }}
      />

      <Stack direction="row" spacing={2} sx={{ mt: 2}}>
        <Button variant="contained" onClick={handleSubmit} fullWidth>
          Подтвердить
        </Button>
        <Button variant="outlined" onClick={handleRefresh} fullWidth>
          Обновить капчу
        </Button>
      </Stack>
    </Box>
  );
}

export default Captcha;
